import './App.css';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';

// Importaciones de componentes
import Login from './Login';
import MapView from './Components/Map';
import Detector from './Components/Detector';
import Alerts from './Components/Alerts';
import Updates from './Components/Updates';
import useToken from './useToken';

// NOTA: Hemos eliminado la importación del Sidebar por completo.

function App() {
  document.body.style.zoom = "100%";
  const { token, setToken } = useToken();
  const email = localStorage.getItem("Login");

  localStorage.setItem("timeScale", "2 Hours");

  // Si no hay token, mostramos la pantalla de Login
  if (!token) {
    return <Login setToken={setToken} />
  }

  // Si hay token, cargamos el enrutador
  return (
    <Router>
      {/* Hemos eliminado los <div className="flex"> y <div className="content"> 
        para que los componentes ocupen toda la pantalla sin restricciones de CSS.
      */}
      <Switch>
        {/* AHORA EL MAPA ES LA PÁGINA PRINCIPAL POR DEFECTO ('/') */}
        <Route path='/' exact={true} component={MapView} />
        
        {/* Mantenemos la ruta /map por compatibilidad si algún enlace viejo apunta aquí */}
        <Route path="/map" exact={true} component={MapView} />
        <Route path="/alerts" exact={true} component={Alerts} />
        <Route path="/detector" exact={true} component={Detector} />
      </Switch>
    </Router>
  );
}

export default App;